import axios from 'axios';

const cloudFuncProdUrl = 'https://us-central1-voteaqui-45be1.cloudfunctions.net/';
const cloudFuncDevUrl = 'https://us-central1-voteaqui-dev.cloudfunctions.net/';

export const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'  ? cloudFuncProdUrl : cloudFuncDevUrl
});